import React from 'react';

import BattlePlanSelector from '@/components/BattlePlanSelector';

export default function CanvassIndex() {
  return (
    <BattlePlanSelector 
      routeType="canvass" 
      title="Canvassing Lists"
      battlePlanTypeFilter="canvassing,gotv-door-knocking"
    />
  );
} 